import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const postAnalyseAttachmentForFraud = async (
  constructPost: ConstructPost,
  attachmentId: string,
  definitionName: string,
): Promise<
  NonPaginatedResponse<{ message: string; analysis_id: string }> | undefined
> =>
  constructPost(
    `${MIDDLE_OFFICE_BASE_PATH}/attachment/${attachmentId}/analyse-fraud`,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
